import { useUserStore } from 'store/user';
import { ADMIN, GUEST, SUPER_ADMIN } from 'common';

export const useUserRole = () => {
  const user = useUserStore((state) => state.user);

  return {
    isLoading: !user,
    isGuest: user?.role === GUEST,
    isAdmin: user?.role === ADMIN,
    isSuperAdmin: user?.role === SUPER_ADMIN,
  };
};
